import type { ResolvedFeatureFlag } from './resolve-feature-flags';

/**
 * Returns true only when a resolved VWO flag places the visitor in a
 * non-control treatment arm.
 *
 * The `ccPatientPrismPhoneSwap` experiment enrolls its whole audience (both
 * arms) with `isEnabled === true`, so `isEnabled` alone is true for ~100% of
 * the experiment audience. Variation 1 is always the control/default; only
 * `variationId > 1` isolates the treatment arm (the 1% pool). Gating on
 * `isEnabled` alone would swap the number for the entire audience instead.
 *
 * Mirrors `getServerFlagVariation`'s `isVariation` gate in
 * clearchoice-marketing. Defaults to `false` (control) for a missing flag,
 * a null/non-numeric `variationId`, or the control variation.
 */
export function isPhoneSwapTreatment(flag: ResolvedFeatureFlag | null | undefined): boolean {
	if (!flag?.isEnabled) return false;
	if (flag.variationId == null) return false;
	return Number(flag.variationId) > 1;
}
